import { NotificationChannel } from "../common/models";

export const DISABLED_NTF_CHANNELS = [NotificationChannel.WHATSAPP];